import { type FC } from "react";
import { DownloadUrlLink } from "../Link";
import { type InvoiceInfoData } from "~/domains/orders/types/models";
import { useTranslation } from "react-i18next";
import { PopperTooltip } from "~/common/components/Tooltip";
import { downloadFile } from "~/common/utils/ApiHelper";

interface DownloadItemBlockProps {
  data: InvoiceInfoData;
  className: string;
}

const DownloadItemBlock: FC<DownloadItemBlockProps> = ({ data, className }) => {
  const { t } = useTranslation();

  let invoice = (
    <div className="scha__order-details-display-print__orders__item__block__main-value">{data.invoiceNo}</div>
  );

  if (data?.invoiceUrl && data?.invoiceNo) {
    invoice = (
      <PopperTooltip tooltipContent={t("orderListPage.downloadInvoices.single.helperLabel")} placement={"bottom-end"}>
        <DownloadUrlLink
          onClick={() =>
            data.invoiceUrl && data.invoiceNo && downloadFile(`${data.invoiceUrl}?id=${data.invoiceNo}&type=INVOICE`)
          }
        >
          {invoice}
        </DownloadUrlLink>
      </PopperTooltip>
    );
  }

  return <div className={"scha__order-details-display-print__orders__item__block " + className}>{invoice}</div>;
};

export default DownloadItemBlock;
